var map = {
	"./authentication/forgot-password/forgot-password.module": [
		"./src/app/main/pages/authentication/forgot-password/forgot-password.module.ts",
		"authentication-forgot-password-forgot-password-module"
	],
	"./authentication/login/login.module": [
		"./src/app/main/pages/authentication/login/login.module.ts",
		"authentication-login-login-module"
	],
	"./authentication/reset-password/reset-password.module": [
		"./src/app/main/pages/authentication/reset-password/reset-password.module.ts",
		"authentication-reset-password-reset-password-module"
	],
	"./export-module/export-module.module": [
		"./src/app/main/apps/export-module/export-module.module.ts",
		"export-module-export-module-module"
	],
	"./import-module/import-module.module": [
		"./src/app/main/apps/import-module/import-module.module.ts",
		"import-module-import-module-module"
	],
	"./main/apps/apps.module": [
		"./src/app/main/apps/apps.module.ts",
		"main-apps-apps-module"
	],
	"./main/pages/pages.module": [
		"./src/app/main/pages/pages.module.ts",
		"main-pages-pages-module"
	],
	"./manage-business/business/business.module": [
		"./src/app/main/apps/manage-business/business/business.module.ts",
		"default~manage-business-business-business-module~manage-restaurants-restaurant-restaurant-module",
		"common",
		"manage-business-business-business-module"
	],
	"./manage-business/businesslist/businesslist.module": [
		"./src/app/main/apps/manage-business/businesslist/businesslist.module.ts",
		"common",
		"manage-business-businesslist-businesslist-module"
	],
	"./manage-restaurants/restaurant/restaurant.module": [
		"./src/app/main/apps/manage-restaurants/restaurant/restaurant.module.ts",
		"default~manage-business-business-business-module~manage-restaurants-restaurant-restaurant-module",
		"common",
		"manage-restaurants-restaurant-restaurant-module"
	],
	"./my-profile/my-profile.module": [
		"./src/app/main/apps/my-profile/my-profile.module.ts",
		"my-profile-my-profile-module"
	],
	"./upload-manual/upload-manual.module": [
		"./src/app/main/apps/upload-manual/upload-manual.module.ts",
		"upload-manual-upload-manual-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;